import employees from "./employees";
import matchings from "./matchings";
import programs from "./programs";

export const expo = {
    employees,
    matchings,
    programs,
};

export default expo;
